import { Paper, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";

import { formatNumber } from "@/features/shared";

// The document total lives in Informasi Umum, next to Terbayar and Sisa, so it
// is deliberately not repeated under this grid.
export const ExpenseAccrualDetailsSection = ({ expenseAccrualDetails }) => (
  <Paper sx={{ p: 2.5, borderRadius: 2 }}>
    <Stack spacing={2}>
      <Typography variant="h6">Rincian Beban</Typography>

      <DataGrid
        rows={expenseAccrualDetails}
        getRowId={(row) => row.id}
        getRowHeight={() => "auto"}
        columns={[
          {
            field: "code",
            headerName: "Akun",
            flex: 1,
            sortable: false,
            valueGetter: (_, row) => row.outletChartOfAccount?.code || "-",
          },
          {
            field: "name",
            headerName: "Nama Akun",
            flex: 2,
            sortable: false,
            valueGetter: (_, row) => row.outletChartOfAccount?.name || "-",
          },
          {
            field: "amount",
            headerName: "Nilai (Rp)",
            flex: 1.5,
            type: "number",
            sortable: false,
            valueFormatter: (value) => formatNumber(value),
          },
          {
            field: "note",
            headerName: "Catatan",
            flex: 2,
            sortable: false,
            valueGetter: (note) => note || "-",
          },
        ]}
        disableRowSelectionOnClick
        hideFooter
      />
    </Stack>
  </Paper>
);

ExpenseAccrualDetailsSection.propTypes = {
  expenseAccrualDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
};
